import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Skill } from '@shared/models';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SkillsService extends ApiService<Skill> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'candidate/';
  }

  getCandidateSoftSkills(candidateId: string | number): Observable<Array<Skill>> {
    return this.get({ url: candidateId + '/skills', params: { type: 'soft' } });
  }

  getCandidateHardSkills(candidateId: string | number): Observable<Array<Skill>> {
    return this.get({ url: candidateId + '/skills', params: { type: 'hard' } });
  }
}
